import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import PdfTableHeader from "./PdfTableHeader";
import PdfTableRow from "./PdfTableRow";
import PdfTableBlankSpace from "./PdfTableBlankSpace";
import PdfTableFooter from "./PdfTableFooter";
import { variables } from "../variables";

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 12,
  },
});

const PdfItemsTable = ({ data, sum, customStyle }) => {
  if (data && data.length) {
    return (
      <View style={styles.tableContainer}>
        <PdfTableHeader data={data} customStyle={customStyle} />
        <PdfTableRow data={data} customStyle={customStyle} />
        <PdfTableBlankSpace
          rowsCount={variables.tableRowsCount - data.length}
          dataLength={data.length}
          customStyle={customStyle}
          data={data}
        />
        {sum && <PdfTableFooter items={data} />}
      </View>
    );
  } else {
    return null;
  }
};

export default PdfItemsTable;